module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "lsqk"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(item.SJ.replace('-', '月')) + "日" + _vm._s(item.TITLE))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.TEXT))]), _vm._v(" "), _c('div', {
      staticClass: "margin-b"
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aeb98fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/nr/lsqk.vue
// module id = 818
// module chunks = 2